// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_printable__yu_c_","nonPrintable":"styles_nonPrintable__xKq2R"};